const APIS = {
    STAFF: "/logisticservice/api/staff/",
    USER: "/usermanagementservice/api/user/",
    USER_PROFILE: "/logisticservice/api/user-profile/",
    PAYMENT_METHOD:"/logisticservice/api/payment-method/"
  };
  
  export default APIS;